export enum SingleChargeStatusEnum {
  Paid = 1,
  NotPaid = 2,
  Canceled = 3,
  Reversed = 4
};

